const version = `20180301.1`
export default version



// WEBPACK FOOTER //
// ./src/app/version.js